import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { FOOTER_COPYRIGHT, FOOTER_LINKS } from '../../constants';
import type { FooterLink } from '../../types';

import styles from './styles.module.css';

const isInternalRoute = (href: string): boolean =>
  href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/#');

const FooterLinkItem: React.FC<{ link: FooterLink }> = ({ link }) => {
  if (link.external) {
    return (
      <a href={link.href} target="_blank" rel="noopener noreferrer">
        {link.label}
      </a>
    );
  }

  if (isInternalRoute(link.href)) {
    // Legal pages open in a new tab so the reader keeps their place; a plain
    // internal link navigates in place.
    return link.newTab ? (
      <Link to={link.href} target="_blank" rel="noopener noreferrer">
        {link.label}
      </Link>
    ) : (
      <Link to={link.href}>{link.label}</Link>
    );
  }

  return <a href={link.href}>{link.label}</a>;
};

const Footer: React.FC = () => {
  const { pathname } = useLocation();
  // A link to the page you're already on is noise — /contact shows only the
  // legal links, matching the design.
  const links = FOOTER_LINKS.filter((link) => link.href !== pathname);

  return (
    <footer className={styles.footer}>
      <div className={styles.shell}>
        <div className={styles.bottom}>
          <span>{FOOTER_COPYRIGHT}</span>
          <div className={styles.legal}>
            {links.map((link) => (
              <FooterLinkItem key={link.label} link={link} />
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
